import TeamIcon from "@mui/icons-material/GroupAdd";

import { AUTH_ROLES } from "api/common/types/auth.types";
import { Product } from "api/memberPortal/project/product/product.types";
import {
  PRODUCT_STATUSES,
  ProductStatus,
} from "api/memberPortal/project/product/productStatuses.type";
import { useIsValidatorResponseTeamMemberQuery } from "api/memberPortal/virtualTeam/virtualTeam.api";
import IconMenuItem from "components/MUI/DataGrid/Cells/Actions/IconMenuItem";
import { useAuth } from "hooks/useAuth";

const validStatuses: readonly ProductStatus[] = [
  PRODUCT_STATUSES.PRE_EVALUATION,
  PRODUCT_STATUSES.IN_PROGRESS,
  PRODUCT_STATUSES.FINALIZING,
  PRODUCT_STATUSES.IN_ASSURANCE_MAINTENANCE,
];

interface ValidationTeamActionProps {
  product: Product;
  setProduct: (_product: Product) => void;
  setShowAmValTeamModal: (_show: boolean) => void;
  setShowValTeamModal: (_show: boolean) => void;
}

const ValidationTeamAction = ({
  product,
  setProduct,
  setShowAmValTeamModal,
  setShowValTeamModal,
}: ValidationTeamActionProps) => {
  const {
    permissions: { is_senior, role_type },
  } = useAuth();
  const { data: isValidatorResponseTeamMember } =
    useIsValidatorResponseTeamMemberQuery();

  const isNIAP = role_type === AUTH_ROLES.NIAP;
  const isSrValAndVrtMember = isValidatorResponseTeamMember && is_senior;

  const inValidStatus = validStatuses.includes(product.status);

  const canView = isNIAP || (isSrValAndVrtMember && inValidStatus);

  const handleClick = () => {
    setProduct(product);
    if (product.status === PRODUCT_STATUSES.IN_ASSURANCE_MAINTENANCE) {
      setShowAmValTeamModal(true);
    } else {
      setShowValTeamModal(true);
    }
  };

  return (
    <IconMenuItem
      Icon={TeamIcon}
      label="Validation Team"
      onClick={handleClick}
      enabled={canView}
    />
  );
};

export default ValidationTeamAction;
